var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodsBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 396.539 396.539",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M264.114,170.801c0.019-1.295-0.594-2.521-1.639-3.283L115.17,59.814c-1.377-1.005-3.236-1.029-4.635-0.062 l-66.141,45.693c-1.08,0.747-1.727,1.978-1.727,3.291c0,1.313,0.646,2.544,1.727,3.291l151.602,104.733 c0.684,0.473,1.479,0.709,2.273,0.709s1.59-0.236,2.273-0.709l61.844-42.725C263.454,173.301,264.097,172.096,264.114,170.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.13,128.798c-1.316-0.689-2.908-0.594-4.134,0.251L208.377,231.727c-1.08,0.746-1.727,1.978-1.727,3.291v157.521 c0,1.486,0.826,2.853,2.143,3.541c0.584,0.308,1.222,0.459,1.857,0.459c0.799,0,1.594-0.239,2.273-0.709l148.619-102.676 c1.082-0.747,1.727-1.979,1.727-3.291V132.34C363.271,130.854,362.446,129.489,361.13,128.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.164,231.727L39.543,129.05c-1.223-0.845-2.813-0.941-4.131-0.251c-1.316,0.69-2.143,2.055-2.143,3.542v157.522 c0,1.313,0.646,2.544,1.727,3.291l148.619,102.676c0.682,0.47,1.477,0.709,2.273,0.709c0.637,0,1.275-0.151,1.859-0.459 c1.316-0.688,2.141-2.055,2.141-3.541V235.018C189.89,233.704,189.246,232.473,188.164,231.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.998,50.003l147.307,107.703c0.703,0.514,1.531,0.771,2.36,0.771c0.793,0,1.589-0.236,2.273-0.709l66.207-45.742 c1.082-0.747,1.727-1.977,1.727-3.291c0-1.314-0.645-2.544-1.727-3.291L200.543,0.708c-1.366-0.945-3.18-0.945-4.546,0 l-61.912,42.775c-1.066,0.736-1.709,1.942-1.727,3.237S132.953,49.241,133.998,50.003z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodsBox);
export default __webpack_public_path__ + "static/media/goods-box.634536ed17243b09fd2bf69d877261e2.svg";
export { ForwardRef as ReactComponent };